<template>
    <b-button type="is-dark" size="is-medium" class="is-fullwidth" icon-left="user-plus">Registrarse</b-button>
</template>
<script>
import ModalShowRegistry from "./ModalShowRegistry.vue";

export default {
    data() {
        return {};
    },
    methods: {
        openModal() {
            this.$buefy.modal.open({
                parent: this,
                component: ModalShowRegistry,
                hasModalCard: true,
                trapFocus: true,
            });
        },
    },
};
</script>